export default __webpack_public_path__ + "static/media/Vector5.c9e1dd3c.svg";